import TooltipCustom from '../../../../atoms/Tooltip/Tooltip';
import { useTranslate } from 'core/hooks/useTranslate';
import Avatar from '../../../../atoms/Avatar/Avatar';
import { rolesLang } from 'core/utils/user';
import React from 'react';

type CreatedByInfoProps = {
  avatar: string;
  name: string;
  role: string;
};

export default function CreatedByInfo({ avatar, name, role }: CreatedByInfoProps) {
  const { t } = useTranslate();

  const tooltipTitle = (
    <div className="created-by-info__tooltip" style={{ textAlign: 'center' }}>
      <span className="created-by-info__tooltip-name">{name}</span>
      <br />
      {role && <span className="created-by-info__tooltip-role">{t(`common:${rolesLang[role]}`)}</span>}
    </div>
  );

  return (
    <div className="created-by-info">
      <TooltipCustom title={tooltipTitle} placement="top" hasArrow>
        <div style={{ display: 'inline-block' }}>
          <Avatar size="sm" image={avatar} />
        </div>
      </TooltipCustom>
    </div>
  );
}
